import { render, staticRenderFns } from "./UserChrome.vue?vue&type=template&id=45b660dc&scoped=true&"
import script from "./UserChrome.vue?vue&type=script&lang=js&"
export * from "./UserChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b660dc",
  null
  
)

export default component.exports